// extracted by mini-css-extract-plugin
export default {"empty":"TenantDevices_empty__JSdKn"};